import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-program-lavel',
  templateUrl: './admin-program-lavel.component.html',
  styleUrls: ['./admin-program-lavel.component.scss']
})
export class AdminProgramLavelComponent implements OnInit {
colorMenu = false;
color = 'warn';
  constructor() { }

  ngOnInit() {
  }

  colors = [
    '#E0E0E0',
    '#F28B82',
    '#FBBC04',
    '#FFF475',
    '#79C70C',
    '#A7FFEB',
    '#CBF0F8',
    '#1CB0F6',
    '#D7AEFB',
    '#F9A4D2',
    '#BC672C',
    '#D7D9DB'
  ]
  colorChange() {    
    if (this.colorMenu)
      this.colorMenu = false
    else
      this.colorMenu = true;
  }
 

}
